import { render } from "./articles.vue?vue&type=template&id=2792bc70"
import script from "./articles.vue?vue&type=script&lang=ts"
export * from "./articles.vue?vue&type=script&lang=ts"
script.render = render

export default script